<template>
  <div class="row">
    <Loader :is-visible="loading" />

    <template v-if="order">
      <div class="col-sm-7">
        <OrderGlobalCard
          v-if="client"
          :order-data="order"
          :client="client"
          :payments="payments"
          :sessions="sessions"
          @reload="loadOrder"
        />

        <MarketingCard v-if="order.marketing" :marketing="order.marketing" />

        <OrderCoachsFilesCard
          v-if="coachsFiles.length"
          :files="coachsFiles"
          :order-id="order.id"
          @deleted="handleCoachFileDeleted"
        />
      </div>

      <div class="col-sm-5">
        <OrderSessionScheduleTrackingCard
          v-if="
            hasPermission($store.state.user, 'SESSION_SCHEDULE_TRACKING_READ')
          "
          :order="order"
          @update="(enabled) => (order.sessionScheduleTracking = enabled)"
        />
        <OrderCommercialCard :order="order" />
        <OrderCoachManagerCard :order="order" />

        <OrderClientCard
          v-if="client"
          :client="client"
          :order="order"
          @reload="loadOrder"
        />

        <OrderVisioCard :order="order" />

        <OrderParticipantsCard v-if="client" :order="order" :client="client" />

        <OrderSignatureSheetsCard
          v-if="client && client.companyId"
          :order="order"
          :client="client"
          :sessions="sessions"
          @reload="loadOrder"
        />
      </div>

      <div v-if="client" class="col-sm-12">
        <NotebookCard :data="notebook" :client="client" :order="order" />
      </div>

      <div class="col-sm-12">
        <OrderPayments
          v-if="client && !order.free"
          :needPayments="needPayments"
          :order="order"
          :client="client"
          :paymentProps="payments"
        />
      </div>

      <div v-if="!order.isForBillingOnly" class="col-sm-12">
        <OrderSessionsCard
          v-if="sessions && order.status !== 'refunded'"
          :sessions="sessions"
          :order="order"
          @reload="loadOrder"
        />
      </div>

      <div class="col-sm-12">
        <OrderLogCard :order="order" />
      </div>
    </template>
  </div>
</template>

<script>
import Loader from "@/components/utils/Loader";
import NotebookCard from "@/components/notebook/NotebookCard";
import MarketingCard from "@/components/marketing/MarketingCard.vue";
import OrderVisioCard from "@/components/order/OrderVisioCard";
import OrderGlobalCard from "@/components/order/OrderGlobalCard";
import OrderCommercialCard from "@/components/order/OrderCommercialCard";
import OrderCoachManagerCard from "@/components/order/OrderCoachManagerCard";
import OrderClientCard from "@/components/order/OrderClientCard";
import OrderPayments from "@/components/order/OrderPayments";
import OrderSessionsCard from "@/components/order/OrderSessionsCard";
import OrderLogCard from "@/components/order/OrderLogCard";
import OrderParticipantsCard from "@/components/order/OrderParticipantsCard";
import OrderSignatureSheetsCard from "@/components/order/OrderSignatureSheetsCard";
import OrderCoachsFilesCard from "@/components/order/OrderCoachsFilesCard";
import OrderSessionScheduleTrackingCard from "@/components/order/OrderSessionScheduleTrackingCard.vue";

export default {
  components: {
    Loader,
    OrderVisioCard,
    OrderGlobalCard,
    OrderCommercialCard,
    OrderCoachManagerCard,
    OrderClientCard,
    OrderPayments,
    OrderSessionsCard,
    OrderLogCard,
    OrderParticipantsCard,
    NotebookCard,
    MarketingCard,
    OrderSignatureSheetsCard,
    OrderCoachsFilesCard,
    OrderSessionScheduleTrackingCard,
  },
  data() {
    return {
      loading: false,

      order: null,
      client: null,
      payments: null,
      sessions: null,
      notebook: [],
      coachsFiles: [],

      needPayments: "",
    };
  },

  async created() {
    await this.loadOrder();
    await this.fetchNotebook();
  },

  methods: {
    async getOrder() {
      try {
        const { data } = await this.$api.get(
          `/orders/${this.$route.params.id}`,
        );

        this.order = data;
      } catch (e) {
        this.$router.push({
          name: "orders",
        });
      }
    },

    async loadOrder() {
      this.loading = true;

      await this.getOrder();

      if (this.order.client && typeof this.order.client === "object") {
        this.client = this.order.client;
      }

      if (this.order.payments) {
        this.payments = this.order.payments;
      }
      if (this.order.sessions) {
        this.sessions = this.order.sessions;
      }

      if (this.order.price >= this.amountDiff(true)) {
        this.needPayments = (parseFloat(this.amountDiff(true)) / 100).toFixed(
          2,
        );
      }

      if (this.order.allowed) {
        let completed = 0;

        this.order.sessions.forEach((s) => {
          if (s.completed || s.assignedAt) {
            completed++;
          }
        });

        if (completed === 0) {
          this.order.allowed = 0;
        }
      }

      this.coachsFiles = this.order.coachsFiles || [];

      this.loading = false;
    },

    async fetchNotebook() {
      try {
        const { data } = await this.$api.get(`/notebook/client`, {
          params: {
            email: this.client.email,
          },
        });

        this.notebook = data;
      } catch (e) {
        console.error(e);
      }
    },

    amountDiff(raw) {
      let payed = 0;

      for (const payment of this.order.payments) {
        if (payment.captured) {
          payed += payment.price;
        }
      }

      return raw
        ? this.order.price - payed
        : this.formatPrice(this.order.price - payed);
    },

    handleCoachFileDeleted(fileId) {
      this.coachsFiles = this.coachsFiles.filter((f) => f.id !== fileId);
    },
  },
};
</script>

<style type="text/css">
.btn-info.float-right {
  margin-left: 4px;
}
</style>
